import Vue from 'vue'
import Component from 'vue-class-component'
import Router, { RouterOptions } from 'vue-router'

Vue.use(Router)

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate'])

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '',
      redirect: 'service-delivery-2019/1'
    },
    {
      path: '/:project',
      redirect: '/:project/1'
    },
    {
      path: '/:project/*',
      name: 'slide',
      props(route) {
        return {
          path: route.path
            .replace(/\/$/, '')
            .split('/')
            .slice(2)
            .map(index => Number(index) - 1)
        }
      },
      component: () => import(/* webpackChunk: "views-presentation" */ '@/views/Presentation.vue')
    }
  ]
} as RouterOptions)
